import { useState, useEffect } from "react";
import api from "../services/api";

const MESES = ["", "Janeiro", "Fevereiro", "Marco", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

const TIPOS = [
  { value: "COMISSAO",      label: "Comissao",      desc: "Comissao variavel + DSR. Encargos completos.",           badge: "primary" },
  { value: "PREMIO",        label: "Premio",         desc: "Premio liquido, sem DSR, sem encargos sobre o premio.",  badge: "warning" },
  { value: "PRODUTIVIDADE", label: "Produtividade",  desc: "Sem DSR, com encargos. Excedente INSS vira Premio.",     badge: "success" },
];

const fmt    = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const fmtPct = (v) => Number(v || 0).toFixed(4) + "%";

function ApresentacaoModal({ resultado: r, tipoAtual, onClose }) {
  const despesas = (r.impostos || 0) + (r.desp_comercial || 0) + (r.desp_administrativa || 0) + (r.beneficios || 0);
  const encargos = (r.decimo_terceiro || 0) + (r.ferias || 0) + (r.fgts || 0);
  const resFinal = r.resultado_final_empresa !== undefined ? r.resultado_final_empresa : r.resultado;
  const isNeg = resFinal < -0.005;
  const isPos = resFinal >  0.005;
  const corRes = isNeg ? "#dc3545" : isPos ? "#198754" : "#6c757d";

  const linhas = [];
  linhas.push(["Salario Fixo (Base+Trienios)", r.salario_fixo_total || 0, true]);
  if (r.tipo_remuneracao === "COMISSAO") {
    linhas.push(["Comissao Variavel", r.comissao_valor, false]);
    if ((r.dsr_valor || 0) > 0) linhas.push(["DSR", r.dsr_valor, false]);
  } else if (r.tipo_remuneracao === "PREMIO") {
    linhas.push(["Premio Liquido", r.premio_valor, true]);
  } else {
    linhas.push(["Produtividade", r.produtividade_valor, false]);
    if ((r.premio_excedente || 0) > 0) linhas.push(["Premio Excedente (liq.)", r.premio_excedente, true]);
  }
  if ((r.premio_adicional || 0) > 0)
    linhas.push(["Premio Adicional (" + (r.premio_adicional_percentual || 0).toFixed(2) + "%)", r.premio_adicional, true]);
  if ((r.premio_resultado_positivo || 0) > 0)
    linhas.push(["Premio s/ Resultado Positivo", r.premio_resultado_positivo, true]);

  return (
    <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.65)", zIndex: 1055 }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content shadow-lg" style={{ borderRadius: 12, overflow: "hidden" }}>
          <div className="modal-header border-0 pb-0"
            style={{ background: "linear-gradient(135deg,#0d1b2a 0%,#1b4332 100%)", color: "#fff", padding: "1.5rem 2rem" }}>
            <div>
              <div className="text-white-50 small mb-1">Horizonte Corretora de Seguros</div>
              <h5 className="fw-bold mb-0">Apuracao de Resultado</h5>
            </div>
            <button className="btn-close btn-close-white ms-auto" onClick={onClose} />
          </div>
          <div className="d-flex justify-content-between align-items-center px-4 py-3"
            style={{ background: "#1b4332", color: "#fff", borderBottom: "3px solid #198754" }}>
            <div>
              <div className="fw-bold fs-5">{r.vendedor_nome}</div>
              <div className="text-white-50 small">{MESES[r.mes]} de {r.ano}</div>
            </div>
            <span className={"badge bg-" + (tipoAtual?.badge || "secondary") + " fs-6 px-3 py-2"}>
              {tipoAtual?.label || r.tipo_remuneracao}
            </span>
          </div>
          <div className="modal-body p-4" style={{ backgroundColor: "#f8f9fa" }}>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-header fw-bold text-white border-0" style={{ background: "#0d6efd", borderRadius: "8px 8px 0 0" }}>
                    Remuneracao do Colaborador
                  </div>
                  <div className="card-body p-0">
                    <table className="table table-sm mb-0">
                      <tbody>
                        {linhas.map(([label, val, destaque]) => (
                          <tr key={label} style={destaque ? { backgroundColor: "#e8f0fe" } : {}}>
                            <td className="ps-3 py-2" style={destaque ? { color: "#0d6efd" } : {}}>{label}</td>
                            <td className="text-end pe-3 py-2 fw-semibold" style={destaque ? { color: "#0d6efd" } : {}}>{fmt(val)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-header fw-bold text-white border-0" style={{ background: corRes, borderRadius: "8px 8px 0 0" }}>
                    Resultado Final da Empresa
                  </div>
                  <div className="card-body text-center py-4">
                    <div className="fw-bold" style={{ fontSize: "2.2rem", color: corRes }}>{fmt(resFinal)}</div>
                    <div className="mt-2 small" style={{ color: corRes }}>{isNeg ? "Abaixo do Esperado" : isPos ? "Acima do Esperado" : "Equilibrado"}</div>
                  </div>
                </div>
              </div>
            </div>
            {r.limite_repasse_aplicado && (
              <div className="alert alert-warning small mt-3 mb-0 py-2">
                Limite de repasse aplicado. Percentual ajustado ao teto configurado.
              </div>
            )}
          </div>
          <div className="modal-footer border-0" style={{ backgroundColor: "#f8f9fa" }}>
            <button className="btn btn-outline-secondary" onClick={onClose}>Fechar</button>
            <button className="btn btn-primary" onClick={() => window.print()}>Imprimir</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Calculo() {
  const [vendedores, setVendedores] = useState([]);
  const [form, setForm] = useState({
    vendedor_id: "",
    producao: "",
    mes: new Date().getMonth() + 1,
    ano: new Date().getFullYear(),
    tipo_remuneracao: "COMISSAO",
  });
  const [resultado, setResultado] = useState(null);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState("");
  const [showApresentacao, setShowApresentacao] = useState(false);
  const [showDeducoes, setShowDeducoes] = useState(false);

  useEffect(() => {
    api.get("/vendedores").then(({ data }) => setVendedores(data));
  }, []);

  const calcular = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setResultado(null);
    try {
      const { data } = await api.post("/calculos", {
        ...form,
        producao: parseFloat(form.producao),
        mes: parseInt(form.mes),
        ano: parseInt(form.ano),
      });
      setResultado(data);
    } catch (err) {
      setError(err.response?.data?.detail || "Erro ao calcular");
    } finally {
      setLoading(false);
    }
  };

  const r = resultado;
  const tipoAtual = TIPOS.find((t) => t.value === form.tipo_remuneracao);
  const resFinal = r ? (r.resultado_final_empresa !== undefined ? r.resultado_final_empresa : r.resultado) : 0;
  const resFinalPos = resFinal >= -0.005;

    return (
      <div>
        <div>
          <h4 className="fw-bold mb-4">Calculo de Comissao</h4>
          <div className="card mb-4 shadow-sm">
            <div className="card-header fw-bold">Novo Calculo</div>
            <div className="card-body">
              <form onSubmit={calcular}>
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Vendedor</label>
                  <select className="form-select" value={form.vendedor_id}
                    onChange={(e) => setForm({ ...form, vendedor_id: e.target.value })} required>
                    <option value="">Selecione</option>
                    {vendedores.map((v) => <option key={v.id} value={v.id}>{v.nome}</option>)}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-semibold">Comissão Auferida (R$)</label>
                  <input type="number" step="0.01" min="0" className="form-control" placeholder="0,00"
                    value={form.producao} onChange={(e) => setForm({ ...form, producao: e.target.value })} required />
                </div>
                <div className="col-md-2">
                  <label className="form-label fw-semibold">Mes</label>
                  <select className="form-select" value={form.mes}
                    onChange={(e) => setForm({ ...form, mes: e.target.value })}>
                    {MESES.slice(1).map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-semibold">Ano</label>
                  <select className="form-select" value={form.ano}
                    onChange={(e) => setForm({ ...form, ano: e.target.value })}>
                    {[2024,2025,2026,2027,2028].map((y) => <option key={y} value={y}>{y}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Tipo de Remuneracao</label>
                  <select className="form-select" value={form.tipo_remuneracao}
                    onChange={(e) => setForm({ ...form, tipo_remuneracao: e.target.value })}>
                    {TIPOS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
                {tipoAtual && (
                  <div className="col-12">
                    <div className={"alert alert-" + (tipoAtual.badge === "warning" ? "warning" : tipoAtual.badge === "primary" ? "primary" : "success") + " py-2 mb-0"}>
                      <strong>{tipoAtual.label}:</strong> {tipoAtual.desc}
                    </div>
                  </div>
                )}
                <div className="col-12">
                  <button className="btn btn-primary px-5" disabled={loading}>
                    {loading ? "Calculando..." : "Calcular"}
                  </button>
                </div>
              </form>
            </div>
          </div>

        {error && <div className="alert alert-danger">{error}</div>}

        {r && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <h5 className="mb-0 fw-bold">{r.vendedor_nome}</h5>
                <span className={"badge fs-6 bg-" + (tipoAtual?.badge || "secondary")}>{r.tipo_remuneracao}</span>
                <span className="text-muted small">{MESES[r.mes]} / {r.ano}</span>
              </div>
              <button className="btn btn-outline-info btn-sm fw-semibold" onClick={() => setShowApresentacao(true)}>
                Apresentar ao Vendedor
              </button>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-md-4">
                <div className="card border-0 shadow h-100" style={{background:"linear-gradient(135deg,#0d6efd,#0dcaf0)"}}>
                  <div className="card-body text-center text-white py-3">
                    <div className="small opacity-75 text-uppercase fw-semibold mb-1">Comissão Auferida</div>
                    <div className="fs-3 fw-bold">{fmt(r.producao)}</div>
                    <div className="small opacity-75 mt-1">{MESES[r.mes]} / {r.ano}</div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 shadow h-100" style={{background:"linear-gradient(135deg,#198754,#20c997)"}}>
                  <div className="card-body text-center text-white py-3">
                    <div className="small opacity-75 text-uppercase fw-semibold mb-1">Total a Receber pelo Vendedor</div>
                    <div className="fs-3 fw-bold">{fmt(r.valor_total_vendedor)}</div>
                    <div className="small opacity-75 mt-1">{MESES[r.mes]} / {r.ano}</div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 shadow h-100" style={{background: resFinalPos ? "linear-gradient(135deg,#198754,#20c997)" : "linear-gradient(135deg,#dc3545,#c0392b)"}}>
                  <div className="card-body text-center text-white py-3">
                    <div className="small opacity-75 text-uppercase fw-semibold mb-1">Resultado da Empresa</div>
                    <div className="fs-3 fw-bold">{fmt(resFinal)}</div>
                    <div className="small opacity-75 mt-1">{resFinalPos ? "Lucro" : "Prejuízo"}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <div className="card h-100 shadow-sm">
                  <div className="card-header fw-semibold bg-light">Composicao do Pagamento</div>
                  <div className="card-body p-0">
                    <table className="table table-sm mb-0">
                      <tbody>
                        <tr><td className="ps-3">Salario Fixo (Base+Trienios)</td><td className="text-end pe-3 fw-semibold">{fmt(r.salario_fixo_total || 0)}</td></tr>
                        {r.tipo_remuneracao === "COMISSAO" && (
                          <>
                            <tr><td className="ps-3">{"Comissao Variavel (" + fmtPct(r.comissao_percentual) + ")"}</td><td className="text-end pe-3 fw-semibold">{fmt(r.comissao_valor)}</td></tr>
                            {(r.dsr_valor || 0) > 0 && <tr><td className="ps-3">DSR</td><td className="text-end pe-3 fw-semibold">{fmt(r.dsr_valor)}</td></tr>}
                          </>
                        )}
                        {r.tipo_remuneracao === "PREMIO" && (
                          <tr><td className="ps-3">{"Premio Liquido (" + fmtPct(r.premio_percentual) + ")"}</td><td className="text-end pe-3 fw-semibold">{fmt(r.premio_valor)}</td></tr>
                        )}
                        {r.tipo_remuneracao === "PRODUTIVIDADE" && (
                          <>
                            <tr><td className="ps-3">{"Produtividade (" + fmtPct(r.produtividade_percentual) + ")"}</td><td className="text-end pe-3 fw-semibold">{fmt(r.produtividade_valor)}</td></tr>
                            {(r.premio_excedente || 0) > 0 && (
                              <>
                                <tr>
                                  <td className="ps-3">
                                    Prêmio Excedente por limite de INSS
                                    <div className="text-muted small fw-normal">Valor pago sem encargos quando a produtividade ultrapassa o limite de INSS configurado.</div>
                                  </td>
                                  <td className="text-end pe-3 fw-semibold">{fmt(r.premio_excedente)}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {(r.premio_adicional || 0) > 0 && (
                          <tr className="table-info">
                            <td className="ps-3">{"Premio Adicional (" + (r.premio_adicional_percentual || 0).toFixed(2) + "% da producao)"}</td>
                            <td className="text-end pe-3 fw-semibold">{fmt(r.premio_adicional)}</td>
                          </tr>
                        )}
                        {(r.premio_resultado_positivo || 0) > 0 && (
                          <tr className="table-success">
                            <td className="ps-3">{"Premio s/ Resultado (" + ((r.percentual_repasse_resultado_positivo || 0) * 100).toFixed(0) + "%)"}</td>
                            <td className="text-end pe-3 fw-semibold">{fmt(r.premio_resultado_positivo)}</td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot>
                        <tr className="table-success">
                          <th className="ps-3">Total a Receber</th>
                          <th className="text-end pe-3">{fmt(r.valor_total_vendedor)}</th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card h-100 shadow-sm">
                  <div className="card-header fw-semibold bg-light">Resultado da Empresa</div>
                  <div className="card-body p-0">
                    <table className="table table-sm mb-0">
                      <tbody>
                        <tr>
                          <td className="ps-3">S2 (antes do premio)</td>
                          <td className={"text-end pe-3 fw-semibold " + ((r.resultado_antes_premio !== undefined ? r.resultado_antes_premio : r.resultado) >= 0 ? "text-success" : "text-danger")}>
                            {fmt(r.resultado_antes_premio !== undefined ? r.resultado_antes_premio : r.resultado)}
                          </td>
                        </tr>
                        {(r.premio_adicional || 0) > 0 && (
                          <tr>
                            <td className="ps-3 text-muted small">{"(-) Premio adicional (" + (r.premio_adicional_percentual || 0).toFixed(2) + "%)"}</td>
                            <td className="text-end pe-3 text-muted">{"- " + fmt(r.premio_adicional)}</td>
                          </tr>
                        )}
                        {(r.premio_resultado_positivo || 0) > 0 && (
                          <tr>
                            <td className="ps-3 text-muted small">{"(-) Premio repassado (" + ((r.percentual_repasse_resultado_positivo || 0) * 100).toFixed(0) + "%)"}</td>
                            <td className="text-end pe-3 text-muted">{"- " + fmt(r.premio_resultado_positivo)}</td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot>
                        <tr className={resFinalPos ? "table-success" : "table-danger"}>
                          <th className="ps-3 fs-5">Resultado Final</th>
                          <th className={"text-end pe-3 fs-5 " + (resFinalPos ? "text-success" : "text-danger")}>{fmt(resFinal)}</th>
                        </tr>
                      </tfoot>
                    </table>
                    {r.limite_repasse_aplicado && (
                      <div className="alert alert-warning py-2 px-3 m-2 small mb-2">
                        Cap aplicado. Taxa sem cap: {fmtPct(r.pct_sem_limite)}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="card shadow-sm mb-4">
              <div className="card-header fw-bold border-bottom pb-2">Decomposicao Completa dos Custos</div>
              <div className="card-body p-0">
                <table className="table table-striped table-sm mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th>Componente</th>
                      <th className="text-end">Percentual</th>
                      <th className="text-end">Valor (R$)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <RemuneracaoVariavelRow resultado={r} />
                    <tr className="table-secondary">
                      <td colSpan={3}><strong>Encargos sobre Salario Base</strong></td>
                    </tr>
                    {[
                      ["Salario Fixo Total (base+trienios)", null, r.salario_fixo_total || 0],
                      ["13 Salario (J2)",         null, r.decimo_terceiro],
                      ["Ferias com Terco (K2)",   null, r.ferias],
                      ["FGTS 8% (L2)",            null, r.fgts],
                    ].map(([label, pct, val]) => (
                      <tr key={label}>
                        <td>{label}</td>
                        <td className="text-end text-muted">{pct || "-"}</td>
                        <td className="text-end fw-semibold">{fmt(val)}</td>
                      </tr>
                    ))}
                    <tr className="table-secondary" style={{cursor:"pointer"}} onClick={() => setShowDeducoes(v => !v)}>
                      <td colSpan={2}>
                        <strong>Deduções sobre Comissão Auferida</strong>
                        <span className="ms-2 text-muted small">
                          {(() => {
                            const total = (r.impostos||0)+(r.desp_comercial||0)+(r.desp_administrativa||0)+(r.lucro_esperado||0);
                            const pct   = r.producao > 0 ? (total/r.producao*100).toFixed(2) : "0.00";
                            return pct + "% | " + fmt(total);
                          })()}
                        </span>
                      </td>
                      <td className="text-end text-muted small">{showDeducoes ? "▲ fechar" : "▼ detalhar"}</td>
                    </tr>
                    {showDeducoes && [
                      ["Impostos (M2)",              "19,75%", r.impostos],
                      ["Desp. Comercial (N2)",        "7,70%",  r.desp_comercial],
                      ["Desp. Administrativa (O2)",   "24,99%", r.desp_administrativa],
                      ["Lucro Esperado (R2)",         "5,00%",  r.lucro_esperado],
                      ["Beneficios (P2)",              null,    r.beneficios],
                    ].map(([label, pct, val]) => (
                      <tr key={label}>
                        <td className="ps-4 text-muted small">{label}</td>
                        <td className="text-end text-muted small">{pct || "-"}</td>
                        <td className="text-end fw-semibold small">{fmt(val)}</td>
                      </tr>
                    ))}
                    {showDeducoes && (r.socios_info || 0) > 0 && (
                      <tr>
                        <td className="ps-4 text-muted small fst-italic">Sócios (Q2 — apenas informativo)</td>
                        <td className="text-end text-muted small">18,63%</td>
                        <td className="text-end text-muted small fst-italic">{fmt(r.socios_info)}</td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="table-info">
                      <th>S2 antes do premio</th>
                      <th></th>
                      <th className="text-end">{fmt(r.resultado_antes_premio !== undefined ? r.resultado_antes_premio : r.resultado)}</th>
                    </tr>
                    {(r.premio_adicional || 0) > 0 && (
                      <tr className="table-info">
                        <th>{"(-) Premio adicional (" + (r.premio_adicional_percentual || 0).toFixed(2) + "%)"}</th>
                        <th></th>
                        <th className="text-end">{"- " + fmt(r.premio_adicional)}</th>
                      </tr>
                    )}
                    {(r.premio_resultado_positivo || 0) > 0 && (
                      <tr className="table-warning">
                        <th>{"(-) Premio repassado (" + ((r.percentual_repasse_resultado_positivo || 0) * 100).toFixed(0) + "%)"}</th>
                        <th></th>
                        <th className="text-end">{"- " + fmt(r.premio_resultado_positivo)}</th>
                      </tr>
                    )}
                    <tr className={resFinalPos ? "table-success" : "table-danger"}>
                      <th>RESULTADO FINAL (S2)</th>
                      <th></th>
                      <th className="text-end">{fmt(resFinal)}</th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </>
        )}
      </div>

      {showApresentacao && r && (
        <ApresentacaoModal
          resultado={r}
          tipoAtual={tipoAtual}
          onClose={() => setShowApresentacao(false)}
        />
      )}
    </div>
  );
}

function RemuneracaoVariavelRow({ resultado: r }) {
  if (r.tipo_remuneracao === "COMISSAO") {
    return (
      <>
        <tr>
          <td>Comissao Variavel (G2)</td>
          <td className="text-end">{fmtPct(r.comissao_percentual)}</td>
          <td className="text-end fw-semibold">{fmt(r.comissao_valor)}</td>
        </tr>
        <tr>
          <td>DSR sobre Comissao (H2)</td>
          <td className="text-end text-muted">-</td>
          <td className="text-end fw-semibold">{fmt(r.dsr_valor)}</td>
        </tr>
      </>
    );
  }
  if (r.tipo_remuneracao === "PREMIO") {
    return (
      <tr>
        <td>Premio Liquido (G2)</td>
        <td className="text-end">{fmtPct(r.premio_percentual)}</td>
        <td className="text-end fw-semibold">{fmt(r.premio_valor)}</td>
      </tr>
    );
  }
  return (
    <>
      <tr>
        <td>Produtividade (G2)</td>
        <td className="text-end">{fmtPct(r.produtividade_percentual)}</td>
        <td className="text-end fw-semibold">{fmt(r.produtividade_valor)}</td>
      </tr>
      {r.premio_excedente > 0 && (
        <tr className="table-warning">
          <td>Prêmio Excedente por limite de INSS (liq.)</td>
          <td className="text-end">{fmtPct(r.premio_percentual)}</td>
          <td className="text-end fw-semibold">{fmt(r.premio_excedente)}</td>
        </tr>
      )}
    </>
  );
}
